export const KEN_LIVE_VERSION = '7.0.5';
export const CONNECTION_VERSION = 'v7.0';
